/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_Q_Need_FinalsInputs */



/**
* | output |
* | --- |
* | "Do I need to run finals?" |
*
* @param {Og_Faq_Q_Need_FinalsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_q_need_finals = /** @type {((inputs?: Og_Faq_Q_Need_FinalsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_Q_Need_FinalsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dois-je organiser une finale ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Es obligatorio organizar finales?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Preciso realizar a final?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Devo giocare le finali?")
	return /** @type {LocalizedString} */ ("Do I need to run finals?")
});